import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AdminLayout } from "@/components/admin/AdminLayout";

export function ProtectedAdminRoute({ children }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 text-gray-500 text-sm">Loading...</div>
    );
  }

  if (!user || (user.role !== "admin" && user.role !== "editor")) {
    return <Navigate to="/admin/login" replace />;
  }

  return <AdminLayout>{children}</AdminLayout>;
}
